const $ = window.jQuery;


const Af = {

    init() {
        const $module = $('#af-container');
        if (!$module.length)
            return;

        const $map = $module.find('.edurus-map-se');
        const $afInfoContainer = $module.find('.af-info')
        const svealand = [
            'Dalarna', 'Narke', 'Sodermanland', 'Uppland', 'Varmland','Vastmanland'
        ];

        const gotaland = [
            'Blekinge', 'Bohuslan', 'Dalsland', 'Halland', 'Skane', 'Smaland', 'Vastergotland', 'Ostergotland', 'Gotland','Oland'
        ];
   
  
        $module.on('click', '.af-item figure', function() {
            $map.find(`.active-landscape`).removeClass('active-landscape');
            $map.find(`.active-landscape-online`).removeClass('active-landscape-online');

            const allLandscapes = $(this).closest('li').attr('data-landskap')
            const url = $(this).closest('li').attr('data-url')
            const antal = $(this).closest('li').attr('data-antal')
            const name = $(this).closest('li').attr('data-name')
            const landScapesArr = allLandscapes.split(",");

            $afInfoContainer.find('.af-kontor-rubrik').text(name)
            $afInfoContainer.find('.af-kontor-rubrik').removeClass('hidden')
            $afInfoContainer.find('.af-antal-kontor span').text(antal)
            $afInfoContainer.find('.af-antal-kontor').removeClass('hidden')
            $afInfoContainer.find('.af-webbadress a').text(url).prop('href', url).removeClass('hidden')
            $afInfoContainer.find('.af-webbadress').removeClass('hidden')
            console.log('clicked')
            var arrayLength = landScapesArr.length;
            for (var i = 0; i < arrayLength; i++) {
             
               
                if (landScapesArr[i] === 'Svealand') {
                    var svealandLentgth = svealand.length;
                    for (var k = 0; k < svealandLentgth; k++) {
                        $map.find(`#Path-${svealand[k]}`).addClass('active-landscape');
                    }

                } else if (landScapesArr[i] === 'Gotaland') {
                    var GotalandLentgth = gotaland.length;
                    for (var k = 0; k < GotalandLentgth; k++) {
                        $map.find(`#Path-${gotaland[k]}`).addClass('active-landscape');
                    }

                } else if (landScapesArr[i] === 'Rikstackande') {
                    $map.find(`[id^="Path-"]`).addClass('active-landscape');
                } else if (landScapesArr[i] === 'Online') {
                    $map.find(`[id^="Path-"]`).addClass('active-landscape-online');
                } else {
                    $map.find(`#Path-${landScapesArr[i]}`).addClass('active-landscape');
                } 
        
            }
            
        });

        $(document).on('mousemove', function (e) {
            $('.pulse2').css({
                left: event.pageX,
                top: event.pageY
            });
        });

        $("body").click(function (event) {
            var clicknode = event.target.nodeName;
            if (clicknode === 'path' || clicknode === 'polygon') {
            } else {
                $('.tooltips').css('display', 'none');
                $('.tooltips').css('opacity', '0');
            }
        });

        $("body").hover(function (event) {
            var clicknode = event.target.nodeName;
            if (clicknode === 'path' || clicknode === 'polygon') {
            } else {
                $('.pulse2').css('display', 'none');
                $('.pulse2').css('opacity', '0');
           
            }
        });


        // Check if ios
        var iOS = !!navigator.platform && /iPad|iPhone|iPod/.test(navigator.platform);
        $("svg.svg2.sweden polygon").css('z-index', '1');
        $("svg.svg2.sweden path").css('z-index', '1');
        $("svg.svg2.sweden shape").css('z-index', '1');
        $("svg.svg2.sweden polygon, svg.svg2.sweden path").hover(
            function () {
                var $land = $(this).attr('id');
                //console.log('id: '+ $land);
                var n = $land.indexOf("Path-");
                //console.log('indenOf: '+ n);
                if (n == 0) {
                    $('svg.svg2.sweden polygon#' + $land + ',svg.svg2.sweden path#' + $land).attr('stroke', '#FFFFFF');
                    $('svg.svg2.sweden polygon#' + $land + ',svg.svg2.sweden path#' + $land).attr('stroke-width', '3.5');
                    $('svg.svg2.sweden polygon#' + $land + ',svg.svg2.sweden path#' + $land).css('cursor', 'pointer !important');
                    $('svg.svg2.sweden polygon#' + $land + ',svg.svg2.sweden path#' + $land).css('position', 'relative');
                    $('svg.svg2.sweden polygon#' + $land + ',svg.svg2.sweden path#' + $land).css('z-index', '99999');
                    $('svg.svg2.sweden polygon#' + $land + ',svg.svg2.sweden path#' + $land).insertAfter($('svg.svg2.sweden polygon').last());
                }
            }, function () {
                var $land = $(this).attr('id');
                $('svg.svg2.sweden polygon#' + $land + ',svg.svg2.sweden path#' + $land).attr('stroke', '#878787');
                $('svg.svg2.sweden polygon#' + $land + ',svg.svg2.sweden path#' + $land).attr('stroke-width', '0.41');
                $('svg.svg2.sweden polygon#' + $land + ',svg.svg2.sweden path#' + $land).css('cursor', 'pointer !important');
                $('svg.svg2.sweden polygon#' + $land + ',svg.svg2.sweden path#' + $land).css('z-index', '1');

            }
        );
        if (iOS === false) {
            $("svg.svg2.sweden polygon, svg.svg2.sweden path, svg.svg2.sweden rect").hover(function () {
                var $land = $(this).attr('id');
                var n = $land.indexOf("Path-");
                if (n == 0) {
                    $('.pulse2').css('display', 'block');
                    $('.pulse2').css('opacity', '1');
                    $('.pulse2').css('left', event.pageX);
                    $('.pulse2').css('top', event.pageY);
                } else {
                    $('.pulse2').css('display', 'none');
                    $('.pulse2').css('opacity', '0');
                }
            });
            $("svg.svg2.sweden polygon, svg.svg2.sweden path, svg.svg2.sweden rect").click(function () {

            });
        } else {
            // Do something
        }
        var width = $(window).width();
        if (iOS === true) {
            $("svg.svg2.sweden polygon,svg.svg2.sweden path").click(function () {
                $(this).hover();
            });
            $("svg.svg2.sweden polygon,svg.svg2.sweden path").hover(function () {
                var $land = $(this).attr('id');
                var n = $land.indexOf("Path-");
                if (n == 0) {
                    var $position = $(this).position();
                    $land = $land.replace('Path-', '');
                    //alert('.tooltips.'+$land);
                    $('.tooltips').css('display', 'none');
                    $('.tooltips').css('opacity', '0');
                    $('.tooltips').css('left', '0');
                    $('.tooltips').css('top', '-3000px');
                    $('.tooltips').css('position', 'fixed');
                    if (width < 1024) {
                        $('.tooltips.' + $land).css('left', '30px');
                        $('.tooltips.' + $land).css('top', '70px');
                        $('.tooltips.' + $land).css('position', 'fixed');
                    } else {
                        $('.tooltips.' + $land).css('left', $position.left - 100);
                        $('.tooltips.' + $land).css('top', $position.top);
                        $('.tooltips.' + $land).css('position', 'absolute');
                    }
                    $('.tooltips.' + $land).css('display', 'block');
                    $('.tooltips.' + $land).css('opacity', '1');
                } else {
                    $('.tooltips').css('display', 'none');
                    $('.tooltips').css('opacity', '0');
                }

            });
        } else {
            $("svg.svg2.sweden polygon,svg.svg2.sweden path").click(function () {
                var $land = $(this).attr('id');
                var n = $land.indexOf("Path-");
                if (n == 0) {
                    var $position = $(this).position();

                    console.log($position);
                    $land = $land.replace('Path-', '');
                    //alert('.tooltips.'+$land);
                    $('.tooltips').css('display', 'none');
                    $('.tooltips').css('opacity', '0');
                    $('.tooltips').css('left', '0');
                    $('.tooltips').css('top', '-3000px');
                    $('.tooltips').css('position', 'fixed');
                    if (width < 1024) {
                        $('.tooltips.' + $land).css('left', '30px');
                        $('.tooltips.' + $land).css('top', '70px');
                        $('.tooltips.' + $land).css('position', 'fixed');
                    } else {
                        $('.tooltips.' + $land).css('left', $position.left - 25);
                        $('.tooltips.' + $land).css('top', $position.top);
                        $('.tooltips.' + $land).css('position', 'absolute');
                    }
                    $('.tooltips.' + $land).css('display', 'block');
                    $('.tooltips.' + $land).css('opacity', '1');
                } else {
                    $('.tooltips').css('display', 'none');
                    $('.tooltips').css('opacity', '0');
                }

            });
        }

    
    },


};

export default Af;